/* @flow @format */

import type { CustomSelector, Selector } from './types';

export type ActionT<+T, +P> = {| +type: T, +payload: P |};

export type ActionCreator<+T, P> = {
  (payload: P): ActionT<T, P>,
  +type: T,
};

export function createAction<T, P>(type: T): ActionCreator<T, P> {
  let ac = (payload: P): ActionT<T, P> => ({ type, payload });
  ac.type = type;
  return ac;
}

export type ActionType<AC> = $Call<<T>((...Iterable<any>) => T) => T, AC>;

export function injectStateSelector<S, T>(stateSelector: Selector<S>): (selector: CustomSelector<S, T>) => Selector<T> {
  return selector => (state, ...rest) => {
    const rootState = stateSelector(state, ...rest);
    return selector(rootState, ...rest);
  };
}

export function reduceReducers(...reducers: any[]) {
  return (prevState: any, action: any, ...rest: any[]) =>
    reducers.reduce((prevState, reducer) => reducer(prevState, action, ...rest), prevState);
}
